module.exports = __webpack_public_path__ + "img/base_hebergements_chambre_hote.1bea6d50.svg";